<template>
  <div id="app">
    <NavBar />

    <div class="app-container">
      <div class="main-content">
        <router-view />
      </div>
    </div>

    <FooterBar />

    <button
      class="theme-toggle"
      @click="toggleTheme"
      :aria-label="isDark ? 'Switch to light mode' : 'Switch to dark mode'"
    >
      {{ isDark ? "☀️" : "🌙" }}
    </button>
  </div>
</template>

<script>
import NavBar from "@/components/layout/NavBar";
import FooterBar from "@/components/layout/FooterBar";

export default {
  name: "App",
  components: {
    NavBar,
    FooterBar,
  },
  data() {
    return {
      theme: "light",
    };
  },
  computed: {
    isDark() {
      return this.theme === "dark";
    },
  },
  mounted() {
    const savedTheme = localStorage.getItem("theme");
    const prefersDark = window.matchMedia(
      "(prefers-color-scheme: dark)"
    ).matches;

    this.theme = savedTheme || (prefersDark ? "dark" : "light");
    document.documentElement.setAttribute("data-theme", this.theme);
  },
  methods: {
    toggleTheme() {
      this.theme = this.theme === "light" ? "dark" : "light";
      document.documentElement.setAttribute("data-theme", this.theme);
      localStorage.setItem("theme", this.theme);
    },
  },
};
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

#app {
  background-color: var(--app-bg);
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.app-container {
  font-family: "Montserrat", sans-serif;
  max-width: 1200px;
  width: 100%;
  margin: 2rem auto 0;
  flex: 1;
}

.main-content {
  background-color: var(--surface-bg);
  width: 100%;
  max-width: 100%;
  color: var(--text-primary);
  box-shadow: var(--shadow-elevation);
  border-radius: 5px;
}

.main-content > * {
  margin-bottom: 0px;
}

/* Responsive Adjustments */
@media (max-width: 1024px) {
  .app-container {
    max-width: 90%;
    margin: 0 auto;
  }
}

@media (max-width: 768px) {
  .app-container {
    max-width: 95%;
  }

  .main-content {
    margin: 1rem auto;
    padding: 1rem;
  }
}

@media (max-width: 480px) {
  .main-content {
    box-shadow: none; /* Remove shadow for small screens */
    border-radius: 0; /* Simplify layout */
  }
}

.theme-toggle {
  position: fixed;
  bottom: 20px;
  right: 20px;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  border: none;
  cursor: pointer;
  background-color: var(--surface-bg);
  color: var(--text-primary);
  box-shadow: var(--shadow-elevation);
  font-size: 1.2rem;
}
</style>
